export const teams = {
    collection: () => `/teams`,
    referral: (inviteHash: string) => `/teams/invites/${inviteHash}`,
    single: (teamId: string) => ({
        members: () => `/teams/${teamId}/members`,
        team: () => `/teams/${teamId}`,
    }),
};
